module.exports = __webpack_public_path__ + "img/default-avatar.522560c.png";